export const RECOGNITION_CACHE = "pindou-recognition-v1";

const coreFiles = [
  "tesseract-core-lstm.js",
  "tesseract-core-lstm.wasm",
  "tesseract-core-lstm.wasm.js",
  "tesseract-core-relaxedsimd-lstm.js",
  "tesseract-core-relaxedsimd-lstm.wasm",
  "tesseract-core-relaxedsimd-lstm.wasm.js",
  "tesseract-core-relaxedsimd.js",
  "tesseract-core-relaxedsimd.wasm",
  "tesseract-core-relaxedsimd.wasm.js",
  "tesseract-core-simd-lstm.js",
  "tesseract-core-simd-lstm.wasm",
  "tesseract-core-simd-lstm.wasm.js",
  "tesseract-core-simd.js",
  "tesseract-core-simd.wasm",
  "tesseract-core-simd.wasm.js",
  "tesseract-core.js",
  "tesseract-core.wasm",
  "tesseract-core.wasm.js",
].map((name) => `/ocr/core/${name}`);

export const RECOGNITION_RESOURCES = [
  "/ocr/worker.min.js",
  "/ocr/eng.traineddata.gz",
  ...coreFiles,
] as const;

export interface OfflinePackStatus {
  state: "idle" | "preparing" | "ready" | "error";
  completed: number;
  total: number;
  error?: string;
}

let status: OfflinePackStatus = { state: "idle", completed: 0, total: RECOGNITION_RESOURCES.length };
let preparation: Promise<void> | null = null;
const listeners = new Set<(value: OfflinePackStatus) => void>();

function publish(next: OfflinePackStatus) {
  status = next;
  listeners.forEach((listener) => listener(next));
}

export function subscribeOfflinePack(listener: (value: OfflinePackStatus) => void) {
  listeners.add(listener);
  listener(status);
  return () => { listeners.delete(listener); };
}

export function prepareOfflineRecognition(): Promise<void> {
  if (preparation) return preparation;
  preparation = (async () => {
    if (!("caches" in window)) throw new Error("当前浏览器不支持离线缓存");
    const cache = await caches.open(RECOGNITION_CACHE);
    let completed = 0;
    publish({ state: "preparing", completed, total: RECOGNITION_RESOURCES.length });
    for (const path of RECOGNITION_RESOURCES) {
      const cached = await cache.match(path);
      if (!cached) {
        const response = await fetch(path, { cache: "reload" });
        if (!response.ok) throw new Error(`离线资源下载失败：${path}`);
        await cache.put(path, response);
      }
      completed += 1;
      publish({ state: "preparing", completed, total: RECOGNITION_RESOURCES.length });
    }
    publish({ state: "ready", completed, total: RECOGNITION_RESOURCES.length });
  })().catch((error: unknown) => {
    preparation = null;
    publish({
      state: "error",
      completed: status.completed,
      total: RECOGNITION_RESOURCES.length,
      error: error instanceof Error ? error.message : "离线识别包下载失败",
    });
    throw error;
  });
  return preparation;
}
